module.exports = __webpack_public_path__ + "it_IT-download-03d71c.webp";